import { useEffect } from "react";

import { useQuery } from "@apollo/client";
import { getMonth, parseISO } from "date-fns";

import { WWW_BUILDING_COLLECTIONS_CALENDAR_AVAILABILITIES_QUERY } from "components/pages/property/listing/graphql";

export const useMinNights = ({ id, checkInDate, guestCount }) => {
  const { loading, error, data, fetchMore, refetch } = useQuery(
    WWW_BUILDING_COLLECTIONS_CALENDAR_AVAILABILITIES_QUERY,
    {
      variables: {
        id,
        checkInDate,
        guestCount,
      },
    },
  );

  // Fetch again if any prop is changed
  useEffect(() => {
    refetch();
  }, [refetch, id, checkInDate, guestCount]);

  const minNights = data?.buildingCollectionsCalendarAvailabilities || [];

  const endCursor = minNights?.[minNights.length - 1]?.date;
  const endCursorMonth = getMonth(parseISO(endCursor));

  const startCursor = minNights?.[0]?.date;
  const startCursorMonth = getMonth(parseISO(startCursor));

  const updateQuery = (
    prevResult,
    { fetchMoreResult, variables: { endCursor } },
  ) => {
    return {
      buildingCollectionsCalendarAvailabilities: [
        ...(endCursor
          ? prevResult.buildingCollectionsCalendarAvailabilities
          : []),
        ...fetchMoreResult.buildingCollectionsCalendarAvailabilities,
        ...(endCursor
          ? []
          : prevResult.buildingCollectionsCalendarAvailabilities),
      ],
      hasMoreResults:
        !!fetchMoreResult.buildingCollectionsCalendarAvailabilities.length,
    };
  };

  const onPrevMonthClick = monthDate => {
    const currentMonth = getMonth(monthDate);
    if (currentMonth <= startCursorMonth) {
      return fetchMore({
        variables: { id, startCursor },
        updateQuery,
      });
    }
  };

  const onNextMonthClick = monthDate => {
    const currentMonth = getMonth(monthDate);
    if (currentMonth + 2 >= endCursorMonth) {
      return fetchMore({
        variables: { id, endCursor },
        updateQuery,
      });
    }

    return () => {};
  };

  return { loading, error, minNights, onPrevMonthClick, onNextMonthClick };
};
